// extracted by mini-css-extract-plugin
module.exports = {"form":"AddProject_form__ZXAV1","spacing":"AddProject_spacing__rpJ0-","select":"AddProject_select__1NrUf"};